import { Stack, Image, ImageFit, PrimaryButton, Dialog, TextField, DialogType, DefaultButton, IStackTokens } from '@fluentui/react';
import React, { useContext, useState } from 'react';
import styles from '../styles/pokemon.module.scss';
import { TProduct } from '../constants/types';
import GlobalContext from '../_contexts/GlobalContext';

export interface IEmailAlertComponentProps {
    card: TProduct;
    userEmail: string;
    callBack: Function;
}

export interface IEmailAlertComponentState {
    hidden: boolean;
    email: string;
};
  
const EmailAlertComponent : React.FunctionComponent<IEmailAlertComponentProps> = (props : IEmailAlertComponentProps) => {
    const [hidden, sethidden] = useState<boolean>(false);
    const [email, setemail] = useState<string>(props.userEmail);

    const { Strings } = useContext(GlobalContext);

    function validation() : boolean {
        let rtnVal = false;
        let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (!email || reg.test(email) === false) {
            rtnVal = true;
        }
        return rtnVal;
    }

    return (   
        <Dialog
            title={Strings.AlertTitle}
            hidden={hidden}
            dialogContentProps={{type:DialogType.normal}}
            onDismiss={() => {sethidden(true);}}
        >
            <Stack horizontalAlign='center'>
                <Stack horizontal verticalAlign='center'>
                    <TextField label="e-mail" type={"email"} placeholder={"voorbeeld@mail.com"} value={email} onChange={(e,v) => {setemail(v);}}></TextField>
                </Stack>
                <br/>
                {props.card?.imageUrls.length && 
                        <Image {...{imageFit: ImageFit.centerContain,
                            className: styles.cardCompImg,
                            src: props.card.imageUrls[0],
                            onError: ( e ) => { e.currentTarget.onerror = null; 
                                                e.currentTarget.src=`${process.env.PUBLIC_URL}/assets/NoImgFound.webp`},
                            styles: props => ({ root: { margin: 0, cursor: "pointer", backgroundColor: "transparent" } }),
                        }} alt="" />}
                <br/>
                <Stack horizontal>
                    <DefaultButton text={Strings.Cancel} onClick={()=>{props.callBack(email);}} />
                    &nbsp;
                    <PrimaryButton disabled={validation()} text={Strings.NotifyMe} onClick={()=>{props.callBack(email, props.card);}} />
                </Stack>
            </Stack>
        </Dialog>
    );
}

export default EmailAlertComponent;